import React from 'react';
import './loader.css';

const Loader = () => {
  return (
    <div className="loader-container" aria-label="Loading" role="alert">
      <div className="loader">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Loader;